import React, { useState, useEffect } from "react";
import {Container, Typography, Grid, Box} from "@mui/material";
import {Card} from '../components/Review/Card';
import {requestApi} from "../utils/utils";


const ListReviews = () => {
	const [trips, setTrips] = useState([]);

	useEffect(async () => {
		const {data} = await requestApi('/rating/get', 'GET');
		if ('data' in data) {
			setTrips(data['data']);
		}
	}, []);

	return (
		<Container maxWidth="lg" sx={{padding: '30px 1.6rem !important'}}>
			<Box style={{maxWidth: '700px', margin: '0 auto 50px auto'}}>
				<Typography variant="h2" component="h1" align="center" style={{fontWeight: '700', textTransform: 'uppercase', fontSize: '3.25rem', letterSpacing: '0.08em', lineHeight: 'unset'}}>Guest Reviews</Typography>
				<Typography variant="h4" component="h3" align="center" style={{marginBottom: '30px', fontSize: '2rem'}}>Don’t just take our word on it!</Typography>
				<Typography variant="p" component="p" align="center"> 
					First hand accounts with real reviews from real guests on real trips. Discover what they really thought about the animals they saw, their experience, our crew, and boats and glamping.
				</Typography>
			</Box>
			<Grid container spacing={8}>
				{trips.length > 0 && 
					trips.map((item, index) => (
						item.total_reviews > 0 &&
						<Grid key={index} item sm={6} md={4} xs={12}>
							<Card {...item}/>
						</Grid>
					))
				}
			</Grid>
		</Container>
	)
};

export default ListReviews;
